import {
  ElementVisibleEvent,
  ScrollProgressEvent,
  TimeSpentEvent,
  useAnalyticsEvents,
} from '@atlassian/mpac-analytics';
import { useEngagementTracking } from '@atlassian/mpac-utils/hooks';
import { useCallback } from 'react';

import { ALL_ELEMENT_IDS } from './pageElementIds';

export const useAgentsPageEngagementAnalytics = () => {
  const fireEvent = useAnalyticsEvents();

  const handleScrollProgress = useCallback(
    (milestone: number) => {
      fireEvent({
        eventType: ScrollProgressEvent,
        actionSubjectId: 'agents-page',
        attributes: {
          scrollPercentage: milestone,
        },
      });
    },
    [fireEvent]
  );

  const handleElementVisible = useCallback(
    (elementId: string) => {
      fireEvent({
        eventType: ElementVisibleEvent,
        actionSubjectId: elementId,
      });
    },
    [fireEvent]
  );

  const handleTimeSpent = useCallback(
    (timeSpent: number) => {
      fireEvent({
        eventType: TimeSpentEvent,
        actionSubjectId: 'agents-page',
        attributes: {
          timeSpent,
        },
      });
    },
    [fireEvent]
  );

  useEngagementTracking({
    elementIds: ALL_ELEMENT_IDS,
    enableScrollTracking: true,
    enableTimeSpentTracking: true,
    rootMargin: '0px',
    threshold: 0.3,
    onScrollProgress: handleScrollProgress,
    onElementVisible: handleElementVisible,
    onTimeSpent: handleTimeSpent,
  });
};
